var map = {
	"./3d.svg": 20655,
	"./account_circle.svg": 92586,
	"./add.svg": 29475,
	"./add_box_outlined.svg": 81938,
	"./admin.svg": 32267,
	"./admin_panel_settings_black_24dp.svg": 95001,
	"./alert.svg": 24608,
	"./analytics.svg": 31254,
	"./annotate.svg": 84074,
	"./apps.svg": 48130,
	"./arrow.svg": 52013,
	"./arrow_forward.svg": 77415,
	"./arrow_right.svg": 33854,
	"./arrow_right_line.svg": 79471,
	"./arrow_upward.svg": 41401,
	"./auto.svg": 75287,
	"./auto_annotate.svg": 43326,
	"./auzoneLogo.svg": 46575,
	"./bar-graph.svg": 48478,
	"./bar-graph_white.svg": 60576,
	"./bar_chart.svg": 13244,
	"./book.svg": 34981,
	"./border_outer_line.svg": 19801,
	"./border_top_line.svg": 86321,
	"./bounding-box.svg": 11522,
	"./box-tool.svg": 75248,
	"./briefcase_outline.svg": 50973,
	"./brush.svg": 58862,
	"./brush_icon.svg": 91762,
	"./call_split.svg": 13771,
	"./cancel_cross.svg": 45953,
	"./cancel_filled.svg": 56891,
	"./cash_plus.svg": 14574,
	"./chart.svg": 88114,
	"./chart_bar_stacked.svg": 54230,
	"./chart_multiple.svg": 36901,
	"./chat.svg": 71660,
	"./check.svg": 14414,
	"./check_circle.svg": 37581,
	"./check_filled.svg": 72477,
	"./chevron_left.svg": 1969,
	"./chevron_right.svg": 80284,
	"./chip.svg": 27336,
	"./clear_all.svg": 24645,
	"./clipboard.svg": 22188,
	"./clock.svg": 60236,
	"./close.svg": 48298,
	"./close_circle.svg": 50825,
	"./cloud_check.svg": 53200,
	"./cloud_servers.svg": 16320,
	"./cloud_upload.svg": 93875,
	"./collapse.svg": 16943,
	"./compare.svg": 25891,
	"./conf_matrix.svg": 79100,
	"./convert.svg": 16347,
	"./copy.svg": 22541,
	"./copy_content.svg": 86431,
	"./copy_white.svg": 95207,
	"./cpu.svg": 11220,
	"./cube.svg": 58733,
	"./cursor.svg": 75056,
	"./dangerous.svg": 44886,
	"./dangerous_outlined.svg": 32791,
	"./darkmode.svg": 55183,
	"./dashboard.svg": 79646,
	"./database.svg": 51789,
	"./database2.svg": 49413,
	"./database_export.svg": 71298,
	"./database_import.svg": 44791,
	"./database_sync.svg": 84089,
	"./dataset.svg": 31886,
	"./dataset_white.svg": 81616,
	"./debug.svg": 62031,
	"./del.svg": 75849,
	"./delete.svg": 65863,
	"./delete_sweep.svg": 38558,
	"./description.svg": 16356,
	"./detection.svg": 61239,
	"./detection2.svg": 74455,
	"./dollar.svg": 55632,
	"./done.svg": 91190,
	"./done_outline.svg": 34921,
	"./dotted_line.svg": 45019,
	"./double_arrow_up.svg": 93629,
	"./download.svg": 92446,
	"./drag_drop.svg": 75968,
	"./dve_logo_and_primary_name.svg": 64362,
	"./earth.svg": 42386,
	"./edgefirst_hexagon.svg": 69028,
	"./edgefirst_hexagon_light.svg": 96425,
	"./edgefirst_logo_and_name.svg": 86123,
	"./edgefirst_name.svg": 12065,
	"./edit.svg": 69338,
	"./ellipsis.svg": 77543,
	"./empty.svg": 50789,
	"./empty_box.svg": 76683,
	"./empty_dataset.svg": 68528,
	"./eraser.svg": 16346,
	"./eraser_icon.svg": 78126,
	"./evaluate.svg": 84331,
	"./evaluate_white.svg": 87829,
	"./event.svg": 70570,
	"./expand.svg": 97122,
	"./expand_less.svg": 24570,
	"./expand_more.svg": 68330,
	"./export.svg": 54288,
	"./external_link.svg": 51526,
	"./eye_icon.svg": 55071,
	"./eye_icon_off.svg": 51433,
	"./feedback.svg": 11939,
	"./file-copy.svg": 318,
	"./file_multiple.svg": 64775,
	"./file_restore.svg": 50271,
	"./file_upload_black_24dp.svg": 73065,
	"./filter_list.svg": 26767,
	"./filter_white.svg": 28054,
	"./flag.svg": 98636,
	"./flip.svg": 63435,
	"./folder.svg": 90006,
	"./folder2.svg": 94552,
	"./folder_zip.svg": 9682,
	"./fullscreen.svg": 22885,
	"./gallery_thumbnail.svg": 28025,
	"./gpu.svg": 68904,
	"./graph-bar.svg": 18646,
	"./graph.svg": 99942,
	"./graph_white.svg": 70904,
	"./grid3x3.svg": 16538,
	"./grid_view.svg": 93430,
	"./hash_tag.svg": 36131,
	"./hashtag.svg": 81490,
	"./height.svg": 96923,
	"./help.svg": 56463,
	"./help_filled.svg": 43950,
	"./hexagon.svg": 51794,
	"./highlight_alt.svg": 77050,
	"./history.svg": 61006,
	"./image.svg": 70213,
	"./image_group.svg": 52537,
	"./image_search.svg": 60004,
	"./import.svg": 94909,
	"./import_export.svg": 82834,
	"./info.svg": 2310,
	"./info_outline.svg": 69145,
	"./info_tip.svg": 33048,
	"./insights.svg": 50909,
	"./invert_colors.svg": 38933,
	"./invert_colors_off.svg": 3431,
	"./kanban.svg": 77387,
	"./key.svg": 56755,
	"./label.svg": 68232,
	"./label2.svg": 60970,
	"./label_white.svg": 45394,
	"./launch.svg": 78975,
	"./layout_2_columns.svg": 26043,
	"./layout_2x1.svg": 14202,
	"./layout_2x2.svg": 98665,
	"./layout_add.svg": 38608,
	"./layout_single.svg": 94903,
	"./linux_os.svg": 91621,
	"./list.svg": 74506,
	"./list_alt.svg": 85722,
	"./list_white.svg": 17772,
	"./log.svg": 25432,
	"./logo-white.svg": 64415,
	"./logout.svg": 63292,
	"./map.svg": 78908,
	"./maximize.svg": 57768,
	"./mcu.svg": 38407,
	"./menu.svg": 13231,
	"./messages.svg": 99578,
	"./messages_white.svg": 61468,
	"./minimize.svg": 1374,
	"./minus_box_outlined.svg": 85693,
	"./model.svg": 20093,
	"./model_white.svg": 37879,
	"./more_vert.svg": 75557,
	"./new_label.svg": 91211,
	"./npu.svg": 5625,
	"./open-in-new.svg": 57855,
	"./open_in_full.svg": 79304,
	"./organizations.svg": 15134,
	"./orthographic.svg": 31128,
	"./outlined_flag.svg": 66597,
	"./palette.svg": 2519,
	"./palette_fill.svg": 64329,
	"./pan_tool.svg": 52324,
	"./params.svg": 92560,
	"./params_white.svg": 33098,
	"./parking.svg": 33186,
	"./paste.svg": 28287,
	"./pause.svg": 77556,
	"./pause_circle.svg": 13295,
	"./payments.svg": 72939,
	"./pencil-off-outline.svg": 57980,
	"./pencil_off.svg": 99495,
	"./pentagon.svg": 48282,
	"./people.svg": 64043,
	"./people_add.svg": 56331,
	"./perf.svg": 54607,
	"./person.svg": 79245,
	"./person_add.svg": 6209,
	"./person_arrow.svg": 48723,
	"./person_settings.svg": 62567,
	"./perspective.svg": 4432,
	"./photo_camera.svg": 97328,
	"./pie_chart.svg": 2297,
	"./place.svg": 16087,
	"./play.svg": 37116,
	"./play_app.svg": 62568,
	"./play_circle.svg": 45431,
	"./play_circle_filled.svg": 22662,
	"./playback_speed.svg": 27953,
	"./preview.svg": 40714,
	"./profile.svg": 71037,
	"./project.svg": 25009,
	"./python.svg": 91508,
	"./receipt.svg": 32790,
	"./refresh.svg": 33571,
	"./remove_selection.svg": 10317,
	"./replay.svg": 29191,
	"./restore.svg": 25400,
	"./review_annotation.svg": 44978,
	"./run_circle.svg": 22328,
	"./run_circle2.svg": 69914,
	"./sam-image.svg": 89739,
	"./sam-video.svg": 94221,
	"./sam.svg": 2683,
	"./savefile.svg": 56075,
	"./scale.svg": 27208,
	"./science.svg": 87032,
	"./screen_share.svg": 65110,
	"./screen_share_filled.svg": 62325,
	"./security.svg": 19164,
	"./segments.svg": 54992,
	"./set.svg": 89246,
	"./settings.svg": 25189,
	"./skip_next.svg": 8253,
	"./skip_previous.svg": 69141,
	"./slideshow.svg": 25110,
	"./snapshot_export.svg": 36451,
	"./snapshot_import.svg": 79430,
	"./sort.svg": 57774,
	"./source_branch.svg": 28608,
	"./source_commit.svg": 94375,
	"./split.svg": 44526,
	"./stats.svg": 69083,
	"./stop.svg": 4870,
	"./stop_circle.svg": 51141,
	"./svg/check-button.svg": 34298,
	"./svg/failed.svg": 28788,
	"./svg/person.svg": 4064,
	"./svg/question.svg": 83359,
	"./svg/user-profile.svg": 64882,
	"./swap.svg": 65823,
	"./swap_horiz.svg": 55672,
	"./sync_alt.svg": 78843,
	"./tag.svg": 11718,
	"./tag_filled.svg": 27365,
	"./test.svg": 94222,
	"./text_snippet.svg": 97433,
	"./toggle_annotation_grid.svg": 23165,
	"./token.svg": 62709,
	"./tool.svg": 42428,
	"./train.svg": 82752,
	"./trainer.svg": 4517,
	"./trash.svg": 90008,
	"./trending_up.svg": 9579,
	"./undo.svg": 6240,
	"./upload.svg": 24341,
	"./usage.svg": 4967,
	"./user.svg": 32751,
	"./val.svg": 90971,
	"./validate.svg": 63276,
	"./verified.svg": 74870,
	"./verified_filled.svg": 68949,
	"./video-3d.svg": 50841,
	"./videocam.svg": 38768,
	"./view_in_ar.svg": 14069,
	"./visibility.svg": 5270,
	"./visibility_off.svg": 36620,
	"./volume_off.svg": 50930,
	"./volume_up.svg": 83508,
	"./voucher.svg": 30092,
	"./warning.svg": 6426,
	"./web.svg": 32900,
	"./width.svg": 28778,
	"./windows_os.svg": 68270,
	"./zoom_to_extents.svg": 57083,
	"./zoom_to_selection.svg": 15618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19832;